const RE_ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Format the "YYYY-MM-DD" an `<input type="date">` produces — "March 5, 2024" in
 * English — or return null for anything else.
 *
 * Built from the date's own parts in UTC, so it is the same on the server and in every
 * time zone: a local-time parse of "2024-03-05" is the evening of March 4 west of
 * Greenwich, and an approval date that moves by a day is a wrong approval date.
 */
export function formatIsoDate(iso: string, locale: string): string | null {
  const match = RE_ISO_DATE.exec(iso.trim());
  if (!match) {
    return null;
  }
  const [year, month, day] = [
    Number(match[1]),
    Number(match[2]),
    Number(match[3]),
  ];
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
    return null;
  }
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
}
